import { Link } from "react-router-dom";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { PageHeader } from "@/components/StatCard";
import DiscoverStrip from "@/components/DiscoverStrip";
import { Wind, Library, CalendarRange, ChevronRight, Play, Siren, Leaf, Activity } from "lucide-react";

function Card({ to, icon: Icon, title, subtitle, testId }) {
  return (
    <Link to={to} data-testid={testId} className="group flex items-center gap-4 rounded-2xl border border-border bg-card p-4 transition-all hover:-translate-y-0.5 hover:shadow-md">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10"><Icon className="h-5 w-5 text-primary" /></span>
      <div className="min-w-0 flex-1">
        <p className="font-display text-base text-foreground">{title}</p>
        <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>
      </div>
      <ChevronRight className="h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
}

export default function Breathwork() {
  const t = useT();
  usePageMeta(t("breathwork"));
  return (
    <div className="space-y-6" data-testid="breathwork-hub">
      <PageHeader eyebrow={t("nav.group.grow")} title={t("breathwork")} subtitle={t("breathwork_subtitle")} />

      <Link to="/app/breathwork/techniques" data-testid="bw-start-hero"
        className="block rounded-2xl bg-primary p-6 text-primary-foreground transition-transform hover:-translate-y-0.5">
        <Wind className="h-7 w-7" />
        <p className="mt-3 inline-flex items-center gap-2 font-display text-xl"><Play className="h-5 w-5" /> {t("breathwork_start_title")}</p>
        <p className="mt-1 text-sm text-primary-foreground/90">{t("breathwork_start_sub")}</p>
      </Link>

      <div className="space-y-3">
        <Card to="/app/breathwork/techniques" icon={Library} title={t("breathwork_techniques_title")} subtitle={t("breathwork_techniques_sub")} testId="bw-open-techniques" />
        <Card to="/app/breathwork/plan" icon={CalendarRange} title={t("breathwork_plan_title")} subtitle={t("breathwork_plan_sub")} testId="bw-open-plan" />
      </div>

      <div className="space-y-3">
        <p className="px-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground/70">{t("panic_attack_btn")} · {t("breathe_easy_btn")}</p>
        <Card to="/app/panic" icon={Siren} title={t("panic_attack_btn")} subtitle={t("panic_attack_btn_sub")} testId="bw-open-panic" />
        <Card to="/app/panic/analytics" icon={Activity} title={t("panic_analytics_title")} subtitle={t("panic_analytics_sub")} testId="bw-open-panic-analytics" />
        <Card to="/app/copd" icon={Leaf} title={t("breathe_easy_btn")} subtitle={t("breathe_easy_btn_sub")} testId="bw-open-copd" />
        <Card to="/app/copd/analytics" icon={Activity} title={t("copd_analytics_title")} subtitle={t("copd_analytics_sub")} testId="bw-open-copd-analytics" />
      </div>

      <DiscoverStrip />
    </div>
  );
}
